/// <amd-module name="Build/CDPipelinesTab/Components/CDPipelinesTabFilterBar" />
import React = require("react");
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { DropdownFilterBarItem } from "VSSUI/Dropdown";
import { FilterBar } from "VSSUI/FilterBar";
import { IListSelection } from "VSSUI/List";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownMultiSelection } from "VSSUI/Utilities/DropdownSelection";
import { Status as StatusComponent, StatusSize } from "VSSUI/Status";
import * as Resources from "Build/CDPipelinesTab/Resources";
import { getStatusIndicatorData, Status } from "Build/Common/Library/Indicator";
import { RunFilterKeys } from "Build/CDPipelinesTab/Constants";
import { Filter, FILTER_APPLIED_EVENT, FILTER_RESET_EVENT } from "VSSUI/Utilities/Filter";

export interface ICDPipelinesTabFilterBarProps {
    updateRunDetailsData: (status: string[]) => void;
}

export class CDPipelinesTabFilterBar extends VssComponent<ICDPipelinesTabFilterBarProps>
{
    private _queuedInfo = getStatusIndicatorData(Status.Queued);
    private _inProgressInfo = getStatusIndicatorData(Status.InProgress);
    private _succeededInfo = getStatusIndicatorData(Status.Succeeded);
    private _warningInfo = getStatusIndicatorData(Status.Warning);
    private _failedInfo = getStatusIndicatorData(Status.Failed);
    private _canceledInfo = getStatusIndicatorData(Status.Cancelled);
    private _stateFilterItems: IListBoxItem[] =
        [
            { id: Status.Queued, text: Resources.Queued, iconProps: { render: () => <StatusComponent {...this._queuedInfo.statusProps} size={StatusSize.m} animated={false} /> } },
            { id: Status.InProgress, text: Resources.Running, iconProps: { render: () => <StatusComponent {...this._inProgressInfo.statusProps} size={StatusSize.m} animated={false} /> } },
            { id: Status.Succeeded, text: Resources.Succeeded, iconProps: { render: () => <StatusComponent {...this._succeededInfo.statusProps} size={StatusSize.m} animated={false} /> } },
            { id: Status.Warning, text: Resources.PartiallySucceeded, iconProps: { render: () => <StatusComponent {...this._warningInfo.statusProps} size={StatusSize.m} animated={false} /> } },
            { id: Status.Failed, text: Resources.Failed, iconProps: { render: () => <StatusComponent {...this._failedInfo.statusProps} size={StatusSize.m} animated={false} /> } },
            { id: Status.Cancelled, text: Resources.Canceled, iconProps: { render: () => <StatusComponent {...this._canceledInfo.statusProps} size={StatusSize.m} animated={false} /> } }
        ];

    constructor(props: ICDPipelinesTabFilterBarProps, context: IVssComponentContext) {
        super(props, context);
        this.statusSelection = new DropdownMultiSelection();
        this._filter = new Filter();
        this._filter.subscribe(this._onFilterUpdated, FILTER_APPLIED_EVENT);
        this._filter.subscribe(this._onFilterUpdated, FILTER_RESET_EVENT);
    }

    public componentDidMount() {
        super.componentDidMount();
    }

    public componentWillUnmount() {
        super.componentWillUnmount();
    }

    public get filter(): Filter {
        return this._filter;
    }

    public dispose() {
        this._filter.unsubscribe(this._onFilterUpdated, FILTER_APPLIED_EVENT);
        this._filter.unsubscribe(this._onFilterUpdated, FILTER_RESET_EVENT);

    }

    public _onFilterUpdated = () => {
        let filterState = this._filter.getState();
        const statusProp = filterState[RunFilterKeys.StatusFilter];
        const status = statusProp ? statusProp.value : "";
        this.props.updateRunDetailsData(status);
    }

    public render() {
        return (
            <div className="page-content-bottom page-content-top">
                <FilterBar filter={this._filter} onDismissClicked={this.onDismiss}>
                    <DropdownFilterBarItem
                        filterItemKey={RunFilterKeys.StatusFilter}
                        items={this._stateFilterItems}
                        containerClassName="status-dropdown"
                        placeholder={Resources.State}
                        selection={this.statusSelection}
                    />

                </FilterBar>
            </div>
        );
    }

    private onDismiss = () => {
        this._filter.reset();
    }

    private statusSelection: IListSelection;
    public _filter: Filter;
}